module.exports = __webpack_public_path__ + "img/facepunch.921fddb1.png";